import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SlotService {

  private apiURL = environment.apiBaseUrl + '/slot';

  constructor(private http: HttpClient) { }

  getSlot(prestazione: string | null, day: string): Observable<any> {
    const timestamp = new Date().getTime();

    return this.http.get<any>(`${this.apiURL}/${prestazione}/${day}?timestamp=${timestamp}`);
  }

  getAllSlot(prestazione: string | null): Observable<any> {
    const timestamp = new Date().getTime();

    return this.http.post<any>(`${this.apiURL}/get-all-slots`, {prestazione: prestazione});
  }
}
